import { SetGetBonusHistoryList } from './thunk/setGetBonusHistoryList'

export const Thunks = {
    SetGetBonusHistoryList
}